import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
const steps = [{
  title: 'Relevamiento y definición del perfil',
  description: 'Trabajamos junto con cada organización para comprender su cultura, los desafíos del rol y las competencias que realmente marcan la diferencia.'
}, {
  title: 'Reclutamiento y atracción de talento',
  description: 'Aplicamos una combinación de publicación estratégica y hunting para atraer y seleccionar al mejor talento.'
}, {
  title: 'Verificación de referencias',
  description: 'Validamos antecedentes y referencias laborales para conocer el desempeño y la trayectoria de la persona.'
}, {
  title: 'Evaluaciones y entrevistas',
  description: 'Utilizamos entrevistas por competencias, Assessment Center y evaluaciones psicotécnicas para medir capacidades y ajuste cultural.'
}, {
  title: 'Presentación de preseleccionados',
  description: 'Enviamos una terna con los mejores perfiles preseleccionados.'
}, {
  title: 'Acompañamiento en el ingreso',
  description: 'Brindamos seguimiento y recursos prácticos para fortalecer la adaptación del nuevo integrante y del equipo.'
}];
export function Process() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section id="como-trabajamos" ref={ref} className="py-32 px-6 bg-gradient-to-b from-emerald-50/40 to-teal-50/30 scroll-mt-20" data-id="element-158">
      <div className="max-w-7xl mx-auto" data-id="element-159">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-160">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6" style={{
          fontFamily: 'Outfit, sans-serif',
          letterSpacing: '-0.02em'
        }} data-id="element-161">
            Cómo trabajamos
          </h2>
          <p className="text-lg text-slate-600 max-w-3xl mx-auto leading-relaxed mb-4" data-id="element-162">
            Diseñamos cada búsqueda a medida de su organización. Nuestro foco
            está en comprender la cultura, reducir la rotación y acelerar una
            incorporación que aporte valor desde el primer día.
          </p>
          <p className="text-base text-slate-500 max-w-2xl mx-auto" data-id="element-163">
            Todos nuestros procesos son 100% confidenciales y resguardan la
            información de tu empresa y de las personas.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-164">
          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.6,
          delay: index * 0.08
        }} className="relative p-8 bg-white rounded-xl border border-emerald-100 hover:border-emerald-200 hover:shadow-md transition-all duration-300" data-id="element-165">
              <div className="absolute -top-5 left-8 w-14 h-14 bg-gradient-to-br from-purple-400 to-purple-500 text-white rounded-full flex items-center justify-center font-bold text-2xl shadow-lg shadow-purple-400/20" data-id="element-166">
                {index + 1}
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3 mt-6" style={{
            fontFamily: 'Outfit, sans-serif'
          }} data-id="element-167">
                {step.title}
              </h3>
              <p className="text-slate-600 leading-relaxed" data-id="element-168">
                {step.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}